import React from 'react';
export function FooterSection() {
  return <footer className="bg-black text-gray-400 py-10 font-body text-sm" data-id="element-44">
      <div className="container mx-auto px-4 text-center" data-id="element-45">
        <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-46">
          <a href="#" className="hover:text-white transition-colors" data-id="element-47">
            Inicio
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-48">
            Política de Reembolso
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-49">
            Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-50">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-51">
            Contacto
          </a>
        </div>
        <p data-id="element-52">
          © {new Date().getFullYear()} Manual de Sanación Natural. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}